import { render, staticRenderFns } from "./TestQuestionFaisabiliteNew.vue?vue&type=template&id=85acf544&scoped=true&"
import script from "./TestQuestionFaisabiliteNew.vue?vue&type=script&lang=js&"
export * from "./TestQuestionFaisabiliteNew.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestionFaisabiliteNew.vue?vue&type=style&index=0&id=85acf544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85acf544",
  null
  
)

export default component.exports